'use client';

import { Typography } from '@ui/uikit/components/common/Typography';
import { Screens } from '@ui/uikit/utils/Screens';

import { LogoCarousel } from '../components/LogoCarousel/LogoCarousel';
import type { LogoCarouselItem } from '../components/LogoCarousel/LogoSlide/LogoSlide';
import { LogoSlide } from '../components/LogoCarousel/LogoSlide/LogoSlide';
import styles from './FeaturedInTopWeb3Section.module.scss';
import { featuredLogo } from './featuredLogo';

const renderItem = (item: LogoCarouselItem) => <LogoSlide key={item.id} height={64} {...item} />;

export const FeaturedInTopWeb3Section = () => {
  return (
    <section className={styles.container}>
      <Typography variant="h1" component="span" textAlign="center">
        Featured in Top Web3 &amp; Tech Media
      </Typography>

      <Screens.Provider>
        <Screens.Breakpoint at="SMALL">
          <LogoCarousel duration={20} items={featuredLogo} renderItem={renderItem} />
        </Screens.Breakpoint>

        <Screens.Breakpoint greaterThan="MEDIUM">
          <ul className={styles.list}>{featuredLogo.map(renderItem)}</ul>
        </Screens.Breakpoint>
      </Screens.Provider>
    </section>
  );
};
